import { createActionsHook } from 'src/lib/sweetState';

import { BrandTermsStore } from './BrandTermsStore';

export const useBrandTermsActions = createActionsHook(BrandTermsStore);
